import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const BreadcrumbContainer = styled(Breadcrumbs)`
  margin-bottom: 48px !important;
`;

export const BreadcrumbItem = styled(Link)`
  font-family: "Inter";
  font-weight: ${({ active }) => (active ? "600" : "400")};
  font-size: 12px;
  color: ${({ active }) => (active ? "#4A3AFF" : "#4a4a4a")};
  text-decoration: none;
`;

export const InactiveBreadcrumbItem = styled.span`
  font-family: "Inter";
  font-weight: ${({ active }) => (active ? "600" : "400")};
  font-size: 12px;
  color: ${({ active }) => (active ? "#4A3AFF" : "#4a4a4a")};
`;
